module.exports = __webpack_public_path__ + "img/briva-light.e8decfae.png";